import React, { useEffect } from 'react';
import Card from './AboutCard';
import MiniCardList from './MiniCardList';

const About = ({ data }) => {
    return (
        <div className='text-white'>
            {data && (
                <>
                    <h1 className='text-center font-bold text-5xl'>About Me</h1>
                    <div className='backdrop-blur bg-white/20 w-4/5 md:max-w-4xl m-auto my-2'>
                        {data.about && (
                            <>
                                <Card
                                    title={data.about.title}
                                    content={data.about.content}
                                    img={data.about.img}
                                />
                            </>
                        )}
                    </div>
                    <div className=''>
                        {data.about_card &&
                            data.about_card.map((item, idx) => {
                                return (
                                    <MiniCardList
                                        key={idx}
                                        heading={item.heading}
                                        list={item.list}
                                    />
                                );
                            })}
                    </div>
                </>
            )}
        </div>
    );
};

export default About;
